import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CepService } from '../modal-cep/cep.service';
import { Endereco } from '../modal-cep/models/endereco.model';
import { Util } from '../../../utils/util';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { MatDialog } from '@angular/material';
import { CepModalComponent } from '../modal-cep/modal-find/cep-modal.component';
import { CepModalListComponent } from '../modal-cep/modal-list/cep-modal-list.component';
import { CepModalInfoComponent } from '../modal-cep/modal-info/cep-modal-info.component';
import { OmniValidators } from '../../../shared/validators';
import { Sacado } from '../models/sacado.model';
import { CollectionService } from '../collection.service';
import { CpfCnpjType } from '../../../shared/enums/cpf-cnpj-type';

@Component({
	selector: 'app-collection-create',
	templateUrl: './create.component.html',
	styleUrls: ['./create.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class CollectionCreateComponent implements OnInit {

	public form: FormGroup;
	public submited = false;
	public disabled = true;
	public adresses: Endereco[] = [];
	public id: any;
	public title = 'Cadastrar Sacado';
	public maskCpfCnpj = '999.999.999-99';

	constructor(
		private route: ActivatedRoute,
		private formBuilder: FormBuilder,
		private router: Router,
		private cepService: CepService,
		public dialog: MatDialog,
		private collectionService: CollectionService
	) {}

	ngOnInit(): void {
		this.buildForm();
		this.route.params.subscribe(params => {
			this.id = params.id;

			if (this.id) {
				this.title = 'Alterar Sacado';
				this.getById();
			}
		});
	}

	getById() {
		this.collectionService.getById(this.id).subscribe(data => {
			if (data.Existe) {
				const sacado = Util.keysToCamel(data.Retorno) as Sacado;
				this.convertModelToForm(sacado);
				this.enableEditMode();
			}
		}, error => {
			console.error(error);
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});

	}

	enableEditMode() {
		this.form.get('cpfCnpj').disable();
		this.form.get('createType').disable();
	}

	buildForm() {
		this.form = this.formBuilder.group({
			createType: [CpfCnpjType.FISICA, Validators.required],
			cpfCnpj: ['', [Validators.required, OmniValidators.isValidCpfCnpj]],
			nome: ['', [Validators.required, OmniValidators.whiteSpace, OmniValidators.completeName]],
			email: ['', [Validators.required, Validators.email]],
			cep: ['', Validators.required],
			uf: ['', Validators.required],
			cidade: ['', Validators.required],
			endereco: ['', Validators.required],
			bairro: ['', Validators.required],
			numero: ['', Validators.required],
			complemento: [''],
		});
	}

	changeType(e: any) {
		this.form.reset();
		this.form.get('createType').setValue(e.value);

		if (this.form.get('createType').value === CpfCnpjType.FISICA) {
			this.maskCpfCnpj = '999.999.999-99';
		} else {
			this.maskCpfCnpj = '99.999.999/9999-99';
		}
	}

	goBack() {
		this.router.navigate(['cobranca']);
	}

	submit() {
		this.submited = true;

		if (this.form.valid) {
			this.save();
		}
	}

	save() {
		const sacado = this.convertFormToModel();
		this.id ? this.edit(sacado) : this.create(sacado);
	}

	create(sacado: Sacado) {
		this.collectionService.post(sacado).subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.router.navigate(['cobranca/detalhes/' + sacado.cPFCNPJ + '/create']);
			}
		}, error => {
			console.error(error, 'error post sacado');
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	edit(sacado: Sacado) {
		this.collectionService.put(sacado).subscribe(data => {
			if (data.Sucesso && data.Existe) {
				this.router.navigate(['cobranca/detalhes/' + sacado.cPFCNPJ + '/edit']);
			}
		}, error => {
			console.error(error, 'error put sacado');
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
		});
	}

	convertFormToModel(): Sacado {
		const sacado = new Sacado();
		sacado.cPFCNPJ = this.removeCharacters(this.form.get('cpfCnpj').value);
		sacado.nome = this.form.get('nome').value;
		sacado.email = this.form.get('email').value;
		sacado.cEP = this.removeCharacters(this.form.get('cep').value);
		sacado.endereco = this.form.get('endereco').value;
		sacado.numero = this.form.get('numero').value;
		sacado.bairro = this.form.get('bairro').value;
		sacado.complemento = this.form.get('complemento').value;
		sacado.cidade = this.form.get('cidade').value;
		sacado.uF = this.form.get('uf').value;
		sacado.codigoLogradouro = 32;

		return sacado;
	}

	convertModelToForm(sacado: Sacado) {
		if (sacado.cPFCNPJ.length > 11) {
			this.form.get('createType').setValue(CpfCnpjType.JURIDICA);
		} else {
			this.form.get('createType').setValue(CpfCnpjType.FISICA);
		}

		this.form.get('cpfCnpj').setValue(sacado.cPFCNPJ);
		this.form.get('nome').setValue(sacado.nome);
		this.form.get('email').setValue(sacado.email);
		this.form.get('cep').setValue(sacado.cEP);
		this.form.get('endereco').setValue(sacado.endereco);
		this.form.get('numero').setValue(sacado.numero);
		this.form.get('bairro').setValue(sacado.bairro);
		this.form.get('complemento').setValue(sacado.complemento);
		this.form.get('cidade').setValue(sacado.cidade);
		this.form.get('uf').setValue(sacado.uF);

		return sacado;
	}

	changeCep () {
		const cep = this.form.get('cep').value;

		if (cep) {
			this.cepService.enderecosPorCep(cep.replace('-', '')).subscribe(data => {
				if (data.Sucesso && data.Existe) {
					this.adresses = Util.keysToCamel(data.Retorno) as Endereco[];
					this.prepareRulesAdresses();
				}
			}, error => {
				this.resetCepValues();
				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			});
		}
	}

	resetCepValues() {
		this.form.get('cep').reset();
		this.form.get('endereco').reset();
		this.form.get('bairro').reset();
		this.form.get('cidade').reset();
		this.form.get('uf').reset();
	}

	showModalCep() {
		const dialogRef = this.dialog.open(CepModalComponent, {
			width: '360px'
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				this.adresses = Util.keysToCamel(result) as Endereco[];
				this.prepareRulesAdresses();
			}
		});
	}

	prepareRulesAdresses() {
		if (this.adresses) {
			if (this.adresses.length === 1) {
				this.updateFormWithAdress(this.adresses[0]);
			} else if (this.adresses.length > 1) {
				this.openModalAdresses();
			}
		}
	}

	openModalAdresses() {
		const dialogRef = this.dialog.open(CepModalListComponent, {
			width: '360px',
			data: this.adresses
		});

		dialogRef.afterClosed().subscribe(result => {
			if (result) {
				const adress = Util.keysToCamel(result) as Endereco;
				this.updateFormWithAdress(adress);
			}
		});
	}

	updateFormWithAdress(address: Endereco) {
		this.form.get('cep').setValue(this.capitalizeFirstLetter(address.cep.toLowerCase()));
		this.form.get('cidade').setValue(this.capitalizeFirstLetter(address.cidade.nome.toLowerCase()));
		this.form.get('uf').setValue(address.cidade.uF);

		if (address.logradouro) {
			const adress = this.capitalizeFirstLetter(address.tipo.toLowerCase()) + ' ' + this.capitalizeFirstLetter(address.logradouro.toLowerCase());
			this.form.get('endereco').setValue(adress);
			this.form.get('endereco').disable();
		} else {
			this.form.get('endereco').enable();
		}

		if (address.bairro.descricao) {
			this.form.get('bairro').setValue(this.capitalizeFirstLetter(address.bairro.descricao.toLowerCase()));
			this.form.get('bairro').disable();
		}else {
			this.form.get('bairro').enable();
		}

	}

	showModalInfo() {
		this.dialog.open(CepModalInfoComponent, {
			width: '500px',
		});
	}

	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	}

	changeCpfCnpj() {
		const cpfCpnj = this.form.get('cpfCnpj').value;
		const type = this.form.get('createType').value;

		if (type === 'fisica' && cpfCpnj.length !== 11) {
			this.form.get('cpfCnpj').setValue('');
		} else if (type === 'juridica' && cpfCpnj.length !== 14) {
			this.form.get('cpfCnpj').setValue('');
		}
	}

	removeCharacters(cpfCnpj: string) {
		return cpfCnpj.replace('-' , '').replace('.' , '').replace('/' , '');
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/collection/create/create.component.ts